import styled from "styled-components";

export const AllMenu = styled.ul`
margin-top: 10px;

  @media (max-width: 1239px) {
    margin-top: 3px;
  }
`;

export const DownloadBtn = styled.button`
  &:hover {
    border: 2px solid var(--background);
  }
  width: 100%;
  height: 47px;
  background-color: var(--blue);
  color: var(--white);
  font-size: 14px;
  margin-bottom: 20px;

  @media (max-width: 767px) {
    width: 100%;
    font-family: "Mulish", sans-serif;
    margin-bottom: 10px;
  }
`;

export const ListItem = styled.li`
  margin-bottom: 5px;
  width: 100%;
`;

interface SpanTitleProps {
  isActive?: boolean;
}

export const SpanTitle = styled.span<SpanTitleProps>`
  font-size: 14px;
  line-height: 1.2;
  padding-left: 5px;
  font-family: "Mulish", sans-serif;
  background: none;
  
  flex: 1 1 0%;
  
  font-weight: 500;
  color: inherit;
  text-decoration: none;

  ${props => props.isActive && `
    color: var(--blue);
        text-decoration: underline dotted rgba(0, 102, 255, 0.5);
    text-underline-offset: 3px;
  `}

  transition: all 0.1s ease-in-out;
`;


export const MenuLink = styled.div`
  &:hover {
    color: var(--blue);
    background-color: var(--sidebar-hover);
    transition:
      border 100ms cubic-bezier(0.17, 0.67, 0.83, 0.67),
      color 100ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  border-radius: 10px;
  background-color: ${(props) =>
    props.$active ? "var(--sidebar-hover)" : undefined};
  color: ${(props) =>
    props.$active ? "var(--blue)" : "var(--black)"};
    span {font-weight: ${(props) =>
      props.$active ? "700" : "500"};
    };
  display: flex;
  align-items: center;
    min-height: 40px;
  height: 40px;
  padding-left: 10px;
  cursor: pointer;
  transition:
    border 100ms cubic-bezier(0.17, 0.67, 0.83, 0.67),
    color 100ms cubic-bezier(0.4, 0, 0.2, 1);

  svg {
    width: 20px;
    height: 20px;
  }
  use {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 767px) {
    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

